"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = EventsList;
var _react = _interopRequireDefault(require("react"));
var _Events = require("../../../SIA-WEBSITE/SIANewsletter/Events/Events");
var _DownloadLinkBox = _interopRequireDefault(require("../../DownloadLinkBox/DownloadLinkBox"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ".sia-informnewsletter-events .title {\n  font-size: 20px;\n  line-height: 26px; }\n\n.sia-informnewsletter-events .downloadlinkbox-container.sia-padding-03-bottom {\n  padding-bottom: 0; }\n";
  const fileName = "EventList_EventList";
  const element = document.querySelector("style[data-sass-component='EventList_EventList']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
function EventsList(_ref) {
  let {
    event_occurrences,
    italian_event_occurences,
    newsletter_date,
    event_labels,
    agenda_url,
    lang,
    ocurrences_bg_color,
    ocurrences_bg_color_it,
    agenda_bg_color
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-informnewsletter-events sia-padding-05-top"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-padding-03-top sia-padding-02-inline sia-padding-05-bottom sia-border-01-top",
    style: {
      background: `${ocurrences_bg_color}`
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "title sia-text-08"
  }, event_labels['cms.inform_newletter.course_teaser']), event_occurrences.map((el, index) => /*#__PURE__*/_react.default.createElement(_Events.EventItem, {
    event: el,
    key: index,
    category: {
      id: 'sia-inform-events'
    },
    lang: lang,
    newsletter_date: newsletter_date
  }))), italian_event_occurences.length > 0 && /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-padding-03-top sia-padding-02-inline sia-padding-05-bottom sia-border-01-top",
    style: {
      background: `${ocurrences_bg_color_it}`
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "title sia-text-08"
  }, event_labels['cms.inform_newletter.course_teaser_italian']), italian_event_occurences.map((el, index) => /*#__PURE__*/_react.default.createElement(_Events.EventItem, {
    event: el,
    key: index,
    category: {
      id: 'sia-inform-events'
    },
    lang: lang,
    newsletter_date: newsletter_date
  }))), agenda_url && /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-padding-03-top sia-padding-02-inline sia-padding-05-bottom sia-border-01-top sia-border-01-bottom",
    style: {
      background: `${agenda_bg_color}`
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-informnewsletter-agenda"
  }, /*#__PURE__*/_react.default.createElement(_DownloadLinkBox.default, {
    items: [{
      link: {
        original_url: agenda_url || `/agenda`,
        title: event_labels['cms.newsletter.events.agenda.link']
      }
    }],
    lang: lang,
    isCMS: false
  }))));
}